const POSITION = {
  START: 'start',
  MIDDLE: 'middle',
  END: 'end'
};
const ZERO_WIDTH_SPACE = '\u200b';

export { POSITION, ZERO_WIDTH_SPACE };
